import { render, staticRenderFns } from "./TableVisitStatus.vue?vue&type=template&id=32d26f62"
import script from "./TableVisitStatus.vue?vue&type=script&lang=js"
export * from "./TableVisitStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports